import React, {
	createContext,
	useContext,
	useState,
	ReactNode,
	useEffect,
} from "react";

// Define types for search modes
export type SearchMode = "guided" | "discovery";

// Define the context state interface
interface SearchContextState {
	searchMode: SearchMode;
	setSearchMode: (mode: SearchMode) => void;
}

// Create the context with default values
const SearchContext = createContext<SearchContextState | undefined>(undefined);

// Provider props interface

const getInitialState = () => {
	return "discovery" as SearchMode;
};

// Search provider component
export const SearchProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [searchMode, setSearchMode] = useState<SearchMode>(getInitialState);
	return (
		<SearchContext.Provider value={{ searchMode, setSearchMode }}>
			{children}
		</SearchContext.Provider>
	);
};

// Custom hook to use the search context
export const useSearch = (): SearchContextState => {
	const context = useContext(SearchContext);

	if (context === undefined) {
		throw new Error("useSearch must be used within a SearchProvider");
	}

	return context;
};
